import { ReactNode } from "react";
import { Badge, BadgeSize, BadgeVariant } from "shared/components";

export const NewBadge = ({
  variant = BadgeVariant.PRIMARY,
  className,
  customBadge,
  destructAfterDate
}: {
  variant?: BadgeVariant;
  className?: string;
  customBadge?: ReactNode;
  /** ISO 8601 date string; once the current date is past it, the badge is hidden. */
  destructAfterDate?: string;
}) => {
  if (destructAfterDate && new Date() > new Date(destructAfterDate))
    return null;

  if (customBadge) return customBadge;

  return (
    <Badge variant={variant} size={BadgeSize.SM} className={className}>
      New
    </Badge>
  );
};
